export default __webpack_public_path__ + "static/media/130.b800f5e3.webp";